import { render, staticRenderFns } from "./LDialog.vue?vue&type=template&id=c3ffce46&"
import script from "./LDialog.vue?vue&type=script&lang=js&"
export * from "./LDialog.vue?vue&type=script&lang=js&"
import style0 from "./LDialog.vue?vue&type=style&index=0&id=c3ffce46&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports